// extracted by mini-css-extract-plugin
export default {"order":"Order_order__kZb45","buttons":"Order_buttons__JlgaO","btn_export":"Order_btn_export__eCd9H","add_button":"Order_add_button__Otllx"};